export default {
  section: 'Market Map',
  config: {
    standalone: true,
    title: 'Market Map Requests',
  },
};
